import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white text-slate-900 font-body">
      <Header />
      <main data-testid="page-main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
